namespace FlogsSenderPrivate {
	export class FlogsSender {
		public constructor() {
			this.createChunk();
			this._currenctChunk.add(true, 0, PandaConsoleMessageLevels.INFO, PlatformDescriber.getInfo().toString(), []);
			this._startTimestamp = DateUtils.now();
		}

		private _logChuncks = new Array<Chunk>();
		private _currenctChunk:Chunk;
		private _startTimestamp:number;
		private _sendSheduled:boolean = false;
		private _errorMessage:string = null;
		private _counter:number = 0;

		private createChunk():void {
			this._currenctChunk = new Chunk();
			this._currenctChunk.onFull.addListener(this.handler_chunkFull);
			this._logChuncks.push(this._currenctChunk);
		}

		public handler_log = (level:PandaConsoleMessageLevel, message:string, args:Array<any>) => {
			let marker:boolean = level === PandaConsoleMessageLevels.WARN || level === PandaConsoleMessageLevels.ERROR;
			this._currenctChunk.add(marker, DateUtils.now() - this._startTimestamp, level, message, args);
			if (marker && !this._sendSheduled && this._counter < 10) {
				PandaConsole.logDebug('send scheduled');
				setTimeout(this.handler_send, 1); // это не nextFrameCall, но и не мгновенная отправка, чтобы текущий стек доделался
				this._sendSheduled = true;
				this._errorMessage = message;
				this._counter++;
			}
		}

		private handler_chunkFull = () => {
			this._currenctChunk.onFull.removeListener(this.handler_chunkFull);
			this.createChunk();
		}

		private handler_send = () => {
			let data:URLVariables = new URLVariables();
			let info = PlatformDescriber.getInfo();
			data.data['project'] = info.project + '_JS';
			data.data['user_id'] = info.userId;
			data.data['client_id'] = info.browserInfo.browser + ' ' + info.browserInfo.version;
			data.data['username'] = info.username;
			data.data['type'] = this._errorMessage;
			data.data['log'] = this.getStringified();
			
			let uri = new URI('').protocol(location.protocol);
			uri.host('flogs.crazypanda.ru');
			uri.path('addlog');
			uri.addSearch('rand',Math.random());
			let req = new URLRequest(uri, 'POST');
			req.data = data.toString();
			req.requestHeaders = new Array<URLRequestHeader>();
			req.requestHeaders.push(new URLRequestHeader('Content-Type', 'application/x-www-form-urlencoded'));
			let loader = new URLLoader(req);
			loader.load();

			PandaConsole.logDebug('sended');

			this._sendSheduled = false;
			this._errorMessage = null;
		}

		public getStringified():string {
			return this._logChuncks.join('...\nskipped\n...\n');
		}
	}

	export class Chunk {
		
		public constructor(contextSize:number = 50) {
			this._contextSize = contextSize;
		}

		public onFull = new Signal<()=>void>();
		private _items = new List<string>('FlogsSenderChunk');
		private _lastMarkerIndex:number = 0;
		private _contextSize:number;
				
		public add(marker:boolean, time:number, level:PandaConsoleMessageLevel, message:string, args:Array<any>):void {
			let stringified = time + ' ' + level + ', ' + message;
			if (args.length) {
				stringified += ', ' + args.join(', ');
			}
			stringified+= '\n';
			
			let items = this._items;
			items.insert(stringified);
			if (marker) {
				this._lastMarkerIndex = items.getLength();
			}

			if (this._lastMarkerIndex === 0 ) {
				if (items.getLength() - this._lastMarkerIndex > this._contextSize) {
					items.remove(items.getHead());
				}
			} else {
				if (items.getLength() - this._lastMarkerIndex >= this._contextSize) {
					this.onFull.emit();
				}
			}
		}

		public toString():string {
			let stringified:string = '';
			let iterator = this._items.getHead();
			while(!iterator.getEnded()) {
				stringified += iterator.getValue();
				iterator.next();
			}
			return stringified;
		}
	}
}

import FlogsSender = FlogsSenderPrivate.FlogsSender;

